import { Box, Card, Link, Text } from '@factorialco/deprecated-design-system'
import { PerformanceInsightsQuantityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { InsightsInfoDot } from 'modules/performance_process/components/insights/InfoDot'

interface PerformanceMetricProps {
  title: string
  description: string | number
  value: PerformanceInsightsQuantityEnum
  onClick?: () => void
  hasLink?: boolean
}

export const InsightMetricCard: React.FC<PerformanceMetricProps> = ({
  title,
  description,
  value,
  onClick,
  hasLink = true,
}) => {
  return (
    <Box
      width="full"
      gridColSpan={{ xxs: 3 }}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <Card key={title}>
        <Card.Title>{title}</Card.Title>
        <Card.Content>
          <Box gap="s16">
            <Box flexDirection="row" gap="s16" alignItems="center">
              <InsightsInfoDot value={value} />
              <Text color="grey1000" weight="semibold" size="600">
                {description}
              </Text>
            </Box>
            {hasLink && (
              <Link.Touchable onClick={onClick}>
                {i18n.t('performance_process.targets.insights.see_more')}
              </Link.Touchable>
            )}
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
